import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../pages/style/Cancel.css';
import { FaTimesCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const CancelCagnotte = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="cancel-page">
      <div className="cancel-box">
        <FaTimesCircle className="cancel-icon" />
        <h2>{t('CancelCagnotte.title')}</h2>
        <p>{t('CancelCagnotte.message')}</p>
        <button onClick={() => navigate('/events')}>{t('CancelCagnotte.Retry')}</button>
      </div>
    </div>
  );
};

export default CancelCagnotte;
